module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page7",
      "title": "7"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "veryfirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part1#_idTextAnchor001"
    }
  }, [_c('b', [_vm._v("Part One: Bottom")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#_idTextAnchor003"
    }
  }, [_vm._v("1 Uncle")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2#_idTextAnchor005"
    }
  }, [_vm._v("2 Why Are You Smiling?")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch3#_idTextAnchor007"
    }
  }, [_vm._v("3 Major Depressive Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idTextAnchor009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Who Am I?")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idTextAnchor011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Help")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part2#_idTextAnchor012",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Two: Borderline")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idTextAnchor014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Home")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idTextAnchor016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Bad Mom")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idTextAnchor018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Origins")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#_idTextAnchor020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Work the Program")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#_idTextAnchor022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 The Color System")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11#_idTextAnchor024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Will the Real Depression Please Stand Up?")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch12#_idTextAnchor026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Escape")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch13#_idTextAnchor028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 The Lord’s Prayer")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part3#_idTextAnchor029",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Three: Breakt­hroughs")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch14#_idTextAnchor031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Thaw")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch15#_idTextAnchor033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Polygamy")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch16#_idTextAnchor035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Hide")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch17#_idTextAnchor037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 And Seek")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch18#_idTextAnchor039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Grow")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch19#_idTextAnchor041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Shame")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page8",
      "title": "8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/ch20#_idTextAnchor043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Best Mom")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch21#_idTextAnchor045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch22#_idTextAnchor047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Forced Praise")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch23#_idTextAnchor049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Still Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/acknowledgments#_idTextAnchor050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idTextAnchor051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', {
    staticClass: "i"
  }, [_vm._v("Still Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author#_idTextAnchor052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/crescendo#_idTextAnchor053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Crescendo")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#_idTextAnchor054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page9",
      "title": "9"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0